import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCommonConfig } from "../../../../../redux/actions";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  matchValidateVersi,
} from "../../../../../helpers/global_helper";
import ConfirmBetDeskonPopup from "../../../../Popups/ConfirmBetDeskonPopup";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";
import SilangPopup from "./SilangPopup";
import { withTranslation } from "react-i18next";
import infoIcon from "../../../../../assets/images/Icons/info_icon.svg";
import { formatPricewithdecimal, formatPrice } from "../../../../NumberFormat";
import CancelledBetDeskonPopup from "../../../../Popups/CancelledBetDeskonPopup";
import { getUserBalance } from "../../../../../redux/actions";
import GameClosedPopup from "../../GameClosedPopup";
import MarketClose from "../../MarketClose";

const SilangVersiWap = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCommonConfig({ key: "gameType", value: "silanghomo" }));
  }, []);

  const [inputs, setInputs] = useState({
    silangDepan: "",
    silangTengah: "",
    silangBelakang: "",
    homoDepan: "",
    homoTengah: "",
    homoBelakang: "",
  });
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [totalData, setTotalData] = useState({});
  const [submitPopup, setSubmitPopup] = useState(false);
  const [submitResult, setSubmitResult] = useState({});
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const closeSubmitPopup = () => {
    setSubmitPopup(false);
    handleReset();
  };

  useEffect(() => {
    if (Object.keys(submitResult).length > 0) {
      setSubmitPopup(true);
    }
  }, [submitResult]);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    const intValue = parseInt(value);
    const minValue = betDiscount.showMin / 1000;
    const maxValue = betDiscount.showMax / 1000;

    // if (intValue < minValue) {
    //   setErrorMessage(`Minimal bet is ${minValue}`);
    //   setShowErrorPopup(true);
    //   return;
    // } else 
    if (intValue > maxValue) {
      setErrorMessage(props.t("The_bet_has_exceeded_the_maximum_bet"));
      setShowErrorPopup(true);
      return;
    }

    if (value === "" || (/^[0-9]*$/.test(value) && !isNaN(intValue))) {
      setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
    }
  }, []);

  useEffect(() => {
    handleReset();
  }, [gameId]);
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const handleReset = () => {
    setInputs({
      silangDepan: "",
      silangTengah: "",
      silangBelakang: "",
      homoDepan: "",
      homoTengah: "",
      homoBelakang: "",
    });
    setTotalData({});
    setTotalCountClick(false);
  };

  const totalCount = (data) => {
    const {
      silangDepan,
      silangTengah,
      silangBelakang,
      homoDepan,
      homoTengah,
      homoBelakang,
    } = inputs;
    if (
      silangDepan === "" &&
      silangTengah === "" &&
      silangBelakang === "" &&
      homoDepan === "" &&
      homoTengah === "" &&
      homoBelakang === ""
    ) {
      showMessage(props.t("guess_bet_wrong"), "error", "error");
      return;
    }
    data = {
      gameId: gameId,
      gameType: "silanghomo",
      databet_silang_depan: silangDepan,
      databet_silang_tengah: silangTengah,
      databet_silang_belakang: silangBelakang,
      databet_homo_depan: homoDepan,
      databet_homo_tengah: homoTengah,
      databet_homo_belakang: homoBelakang,
      fastbet: true,
      multiple: betDiscount.showMultiple
    };

    let matchValidate = matchValidateVersi(gameType, data);
    if (matchValidate) {
      if (matchValidate == "format_input") {
        setErrorMessage(props.t(matchValidate));
        setShowErrorPopup(true);
        return;
      } else {
        setErrorMessage(props.t("format_input_on") + " " + matchValidate);
        setShowErrorPopup(true);
        return;
      }
    }

    makeAjax(url.TOGEL_API.processDataBet, data).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          showMessage(response.code, "error", "error");
          setTotalData({});
          return;
        }
        showMessage(response.code, "error", "error");
        setTotalData({});
        return;
      }
      setTotalData(response.data);
      setTotalCountClick(true);
    });
  };

  const submitProcess = (data) => {
    if (totalCountClick) {
      setShowConfirmationPopup(true);
    } else {
      const {
        silangDepan,
        silangTengah,
        silangBelakang,
        homoDepan,
        homoTengah,
        homoBelakang,
      } = inputs;
      if (
        silangDepan === "" &&
        silangTengah === "" &&
        silangBelakang === "" &&
        homoDepan === "" &&
        homoTengah === "" &&
        homoBelakang === ""
      ) {
        showMessage(props.t("guess_bet_wrong"), "error", "error");
        return;
      }
      data = {
        gameId: gameId,
        gameType: "silanghomo",
        databet_silang_depan: silangDepan,
        databet_silang_tengah: silangTengah,
        databet_silang_belakang: silangBelakang,
        databet_homo_depan: homoDepan,
        databet_homo_tengah: homoTengah,
        databet_homo_belakang: homoBelakang,
        fastbet: true,
        multiple: betDiscount.showMultiple
      };

      let matchValidate = matchValidateVersi(gameType, data);
      if (matchValidate) {
        if (matchValidate == "format_input") {
          setErrorMessage(props.t(matchValidate));
          setShowErrorPopup(true);
          return;
        } else {
          setErrorMessage(props.t("format_input_on") + " " + matchValidate);
          setShowErrorPopup(true);
          return;
        }
      }

      makeAjax(url.TOGEL_API.processDataBet, data).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
          if (response.code !== "validation_error") {
            showMessage(response.code, "error", "error");
            setTotalData({});
            return;
          }
          showMessage(response.code, "error", "error");
          setTotalData({});
          return;
        }
        setTotalData(response.data);
      });
      setShowConfirmationPopup(true);
    }
    // const { silangDepan, silangTengah, silangBelakang, homoDepan, homoTengah, homoBelakang } = inputs;

    // if (silangDepan.trim() === '' &&
    //   silangTengah.trim() === '' &&
    //   silangBelakang.trim() === '' &&
    //   homoDepan.trim() === '' &&
    //   homoTengah.trim() === '' &&
    //   homoBelakang.trim() === '') {
    //   setErrorMessage('Incorrect Input Format.');
    //   setShowErrorPopup(true);
    //   return;
    // }
    // setShowConfirmationPopup(true);
  };

  const submitSilang = (data) => {
    setShowConfirmationPopup(false);
    const dataangka = [];
    const {
      silangDepan,
      silangTengah,
      silangBelakang,
      homoDepan,
      homoTengah,
      homoBelakang,
    } = inputs;

    const checkAndPush = (condition, label, value) => {
      if (condition) {
        dataangka.push([label, value * betDiscount.showMultiple, "success"]);
      } else {
        dataangka.push(["", "", "null"]);
      }
    };

    checkAndPush(
      silangDepan != 0 && silangDepan != "",
      "Silang-Depan",
      silangDepan
    );
    checkAndPush(
      silangTengah != 0 && silangTengah != "",
      "Silang-Tengah",
      silangTengah
    );
    checkAndPush(
      silangBelakang != 0 && silangBelakang != "",
      "Silang-Belakang",
      silangBelakang
    );
    checkAndPush(homoDepan != 0 && homoDepan != "", "Homo-Depan", homoDepan);
    checkAndPush(
      homoTengah != 0 && homoTengah != "",
      "Homo-Tengah",
      homoTengah
    );
    checkAndPush(
      homoBelakang != 0 && homoBelakang != "",
      "Homo-Belakang",
      homoBelakang
    );

    data = {
      gameId: gameId,
      dataangka: dataangka,
      gameType: "silanghomo",
      action: "process",
      allowPartner: "allowPartner",
      betTogelAuth: "betTogelAuth",
      fastbet: true,
    };

    makeAjax(url.TOGEL_API.processAltTogel, data).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code))
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data found", "error", "error");
        return;
      }
      setSubmitResult(response.data);
      dispatch(getUserBalance());
    });
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };

  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* --- Rules ---  */}
          <div className="rules_container">
            <div>
              <p>{props.t('silang_kembang_silang_text')}</p>
              <p>Format Tarun: Nominal taruhan sesuai konversi</p>
              <p>Conoth Penulisan: 1 pada Panel</p>
            </div>
            <div className="rules_conversion">
              <p>
                Konversi <br /> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          {/* --- Rules ---  */}
          <div class="versicontainer_input">
            <div class="versicontainer_inputleft">
              <label for="input_left">Silang Depan</label>
              <input
                type="text"
                name="silangDepan"
                value={inputs.silangDepan}
                onChange={handleInputChange}
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Bet"
              />
            </div>
            <div class="versicontainer_inputright">
              <label for="input_right">Homo Depan</label>
              <input
                type="text"
                name="homoDepan"
                value={inputs.homoDepan}
                onChange={handleInputChange}
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Bet"
              />
            </div>
          </div>

          {/* 2nd row */}
          <div class="versicontainer_input">
            <div class="versicontainer_inputleft">
              <label for="input_left">Silang Tengah</label>
              <input
                type="text"
                name="silangTengah"
                value={inputs.silangTengah}
                onChange={handleInputChange}
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Bet"
              />
            </div>
            <div class="versicontainer_inputright">
              <label for="input_right">Homo Tengah</label>
              <input
                type="text"
                name="homoTengah"
                value={inputs.homoTengah}
                onChange={handleInputChange}
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Bet"
              />
            </div>
          </div>

          {/* 3rd row */}
          <div class="versicontainer_input">
            <div class="versicontainer_inputleft">
              <label for="input_left">Silang Belakang</label>
              <input
                type="text"
                name="silangBelakang"
                value={inputs.silangBelakang}
                onChange={handleInputChange}
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Bet"
              />
            </div>
            <div class="versicontainer_inputright">
              <label for="input_right">Homo Belakang</label>
              <input
                type="text"
                name="homoBelakang"
                value={inputs.homoBelakang}
                onChange={handleInputChange}
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Bet"
              />
            </div>
          </div>

          {/* 1 */}
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="result_left">
                <p>
                  <span>Total {props.t("line")}</span> :{" "}
                  {totalData.line ? totalData.line : "-"}
                </p>
                <p>
                  <span>Total {props.t("purchases")}</span> :{" "}
                  {totalData.tover ? formatPrice(totalData.tover) : "-"}
                </p>
              </div>
              <div className="result_right">
                <p>
                  <span>Total {props.t("discount")}</span>:{" "}
                  {totalData.disc
                    ? formatPricewithdecimal(totalData.disc)
                    : "-"}
                </p>
                <p>
                  <span>Total {props.t("payment")}</span> :{" "}
                  {totalData.pay ? formatPricewithdecimal(totalData.pay) : "-"}
                </p>
              </div>
              <div className="info_icon">
                <img src={infoIcon} alt="" onClick={toggleTooltip} />
                {showTooltip && (
                  <div
                    className="info_icon_overlay"
                    onClick={() => setShowTooltip(false)}
                  ></div>
                )}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">
                        Contoh Format Taruhan
                      </span>
                      <span className="tooltip_content">
                        bet silang, homo, depan, tengah, belakang
                      </span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                Konversi<br></br> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>

          {/* button*/}
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={totalCount}>{props.t("count_total")}</button>
              </div>
              <div className="button_right">
                <button onClick={handleReset}>{props.t('reset')}</button>
              </div>
            </div>
            <div className="versiweb_result_right btn_Submit">
              <button onClick={submitProcess}>{props.t('submit')}</button>
            </div>
          </div>
        </>
      )}

      {
        /*---error popup --*/
        showErrorPopup && (
          <ErrorInnerPopup
            modalTitle={""}
            modalHeader={true}
            onCloseModal={() => setShowErrorPopup(false)}
          >
            <ErrorPopup
              message={errMessage}
              onClose={() => setShowErrorPopup(false)}
            />
          </ErrorInnerPopup>
        )
      }

      {submitPopup && (
        <SilangPopup onClose={closeSubmitPopup} submitResult={submitResult} />
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          submitProcessOk={submitSilang}
        />
      )}

      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
      )}
    </div>
  );
};

export default withTranslation()(SilangVersiWap);
